export default () => {
    return [
        {
            path: '/tasks',
            name: 'tasks',
            component: () => import('./views/tasks.vue'),
        },
    ];
};
